import { render, staticRenderFns } from "./UserNamePassword.vue?vue&type=template&id=0865f128"
import script from "./UserNamePassword.vue?vue&type=script&lang=js"
export * from "./UserNamePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports